export default __webpack_public_path__ + "static/media/la-regular-400.77111476.eot";